import { nanoid } from 'nanoid';
import { sendCrossTabEvent, NameSpaces } from 'modules/EventsManager/eventsManager';
import { PageTypes } from 'utils/pageTypes';

const TOAST_SEVERITY = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
} as const;

export function showToastMessage(message: string, severity: keyof typeof TOAST_SEVERITY = 'INFO') {
  sendCrossTabEvent(NameSpaces.CROSS_TAB_NOTIFICATION, {
    type: 'showCrossTabNotification',
    payload: {
      toastKey: nanoid(),
      targetPageTypes: [PageTypes.VIEWER],
      position: 'top-right',
      isUnique: true,
      severity: TOAST_SEVERITY[severity] || TOAST_SEVERITY.INFO,
      message,
    },
  });
}
